import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=aa419878&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"
import style0 from "./Access.vue?vue&type=style&index=0&id=aa419878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa419878",
  null
  
)

export default component.exports